import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import ComputerCharts from 'assets/images/computer-charts-magnifying-glass.svg'

import i18n from 'modules/core/lib/i18n'

const BlankSlate = () => (
  <Box gap="s24" flexDirection="column" justifyContent="center" alignItems="center" height="full">
    <img src={ComputerCharts} />
    <Box textAlign="center" paddingX="s24">
      <Text.Normal>{i18n.t('competencies_v2.ninebox.empty')}</Text.Normal>
    </Box>
  </Box>
)

export default BlankSlate
